export let flaggedFilter = "MIgFHe";
export default {flaggedFilter};